<template>
  <v-dialog transition="dialog-bottom-transition" width="auto">
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" color="orange-lighten-2" variant="text">
        Cotizar
      </v-btn>
    </template>
    <template v-slot:default="{ isActive }">
      <v-card class="cardSize">
        <v-toolbar color="primary" :title="name">
          <v-btn icon dark @click="isActive.value = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="red"
        ></v-progress-linear>

        <v-card-text>
          <alert-component
            v-if="alert"
            :tipo="'success'"
            :titulo="'Listo!'"
            :descripcion="'Puedes revisar tu cotización en el carrito. Gracias!'"
          />
          <alert-component
            v-if="alert2"
            :tipo="'warning'"
            :titulo="'Aviso'"
            :descripcion="'Debes seleccionar un color'"
          />
          <v-btn variant="outlined" prepend-icon="mdi-cart" to="/carrito" block>
            Ir al carrito
          </v-btn>
          <v-container>
            <v-row>
              <v-col>
                <p class="txtdata">MEDIDAS</p>
              </v-col>
              <v-col> </v-col>
            </v-row>
            <v-row v-for="(opcion, index) in opciones" :key="index">
              <v-col cols="6" class="d-flex align-items-center">
                <li class="txtdata">{{ opcion.medida }}</li>
              </v-col>

              <v-col cols="4" class="d-flex align-items-center">
                <v-text-field
                  label="Cantidad"
                  v-model.number="opcion.cantidad"
                  style="font-size: smaller"
                  placeholder="cantidad"
                  variant="solo"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn
                  class="txtbutton"
                  variant="flat"
                  color="green-darken-3"
                  @click="incrementarCantidad(index)"
                  size="small"
                  :disabled="loading"
                  >+</v-btn
                >
                <v-spacer style="height: 5px"></v-spacer>
                <v-btn
                  class="txtbutton"
                  variant="flat"
                  color="red-darken-3"
                  @click="decrementarCantidad(index)"
                  size="small"
                  :disabled="loading"
                  >-</v-btn
                >
                <v-spacer style="height: 5px"></v-spacer>
                <v-btn
                  class="txtbutton"
                  variant="flat"
                  color="orange-darken-3"
                  @click="
                    addProductToCart(
                      opcion.id + selectColor.id,
                      name,
                      opcion,
                      selectColor
                    )
                  "
                  size="small"
                  :disabled="loading"
                  ><span class="mdi mdi-cart-plus"></span
                ></v-btn>
              </v-col>
              <v-select
                label="Colores"
                :items="colores"
                item-title="color"
                return-object
                variant="solo"
                v-model="selectColor"
              ></v-select>
              <v-divider></v-divider>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VariantesDetailComponent from './VariantesDetailComponent.vue';
import AlertComponent from './AlertComponent.vue';

export default {
  props: {
    id: {
      type: String,
      default:''
    },
    colores:{
      type:Array,
      default: ()=>[]
    },
    name: {
      type:String,
      default: ''
    },
    opciones:{
      type:Array,
      default:()=>[]
    },
  },
  mounted() {},
  data() {
    return {
      precioTotal: 0,
      selectColor: [],
      loading: false,
      alert: false,
      alert2: false,
    };
  },

  components: {
    VariantesDetailComponent,
    AlertComponent,
  },
  computed: {
    ...mapGetters(['cartItems']),
  },

  methods: {
    incrementarCantidad(index) {
      this.opciones[index].cantidad++;
    },
    decrementarCantidad(index) {
      if (this.opciones[index].cantidad > 0) {
        this.opciones[index].cantidad--;
      }
    },

    ...mapActions(['addToCart', 'removeFromCart']),

    addProductToCart(id, nombre, data, selectColor) {
      this.alert = false;
      this.alert2 = false;

      if (selectColor != '') {
        this.loading = true;
        var item = {
          id: id,
          nombre: nombre,
          datos: data,
          color: selectColor,
        };
        this.addToCart(item);
      } else {
        this.alert2 = true;
      }
    },
    removeProductFromCart(productId) {
      this.removeFromCart(productId);
    },
  },
  watch: {
    loading(val) {
      if (!val) return;

      setTimeout(() => ((this.loading = false), (this.alert = true)), 2000);
    },
  },
};
</script>

<style scoped>
@media (min-width: 1000px) {
  /* Ajusta este valor según el breakpoint que desees */
  .cardSize {
    width: 500px;
  }
}

@media (max-width: 999px) {
  .cardSize {
    margin: auto;
  }
}
.txtbutton {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 600;
  font-size: medium;
}
.txtdata {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 600;
}
</style>
